import { createSelector } from 'reselect';

import PlaceName from '../../models/interfaces/PlaceName';
import { Store } from '../reducers/reducers';
import { placePermissionsSelector } from './authenticationSelectors';

const companySelector = (store: Store) => store.companyReducerState;

export const employeesSelector = createSelector(companySelector, ({ employees }) => employees);

export const placeNamesSelector = createSelector(companySelector, ({ companyPlaces }) => Array.from(companyPlaces.values()));

export const placeNameSelector = (placeUuid: string) =>
  createSelector(companySelector, ({ companyPlaces }) => companyPlaces.find((placeName) => placeName.uuid === placeUuid));

export const placeNamesLookupSelector = createSelector(companySelector, ({ companyPlaces }) => companyPlaces.toJS() as { [key: string]: PlaceName });

export const authorizedPlaceNamesSelector = createSelector(placeNamesSelector, placePermissionsSelector, (placeNames, placePermissions) =>
  placeNames.filter((placeName) => placePermissions.some((placePermission) => placeName.uuid === placePermission.placeUuid))
);

export const companyGuestsSelector = createSelector(companySelector, ({ guests }) => guests);
